import React, { useState } from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    TextField,
    Button,
    TableContainer,
    Grid,
} from "@material-ui/core";
import { useStyles, StyledTableCell } from "../../adminStyles";

import ExcelExport from "./ExportExcel";

const VacationHourTable = props => {
    const [searchTerm, setSearchTerm] = useState("");
    const {
        tableRoot,
        sortLabel,
        approveBtn,
        tableContainer,
        gridElRight,
        gridElLeft,
        inputMobile,
    } = useStyles();

    const { columns, rows, orderAscending, orderBy, asc } = props;

    const setTheSearchTerm = e => {
        setSearchTerm(e.target.value.trim().toLowerCase());
    };

    // Improved filter that works with various column ids
    const filteredRows = rows.filter(row => {
        return columns.some(column => {
            const rowData = (row[column.id] || "").toString().toLowerCase();
            return rowData.includes(searchTerm);
        });
    });

    // Ensure we pass only filtered or all rows to the ExcelExport based on search term
    const userTableProps = {
        columns,
        row: searchTerm ? filteredRows : rows,
        orderAscending,
        asc,
        ...props,
    };

    const renderStyledTableCell = () =>
        columns.map(column => (
            <StyledTableCell
                key={column.id}
                align="center"
                padding={column.disablePadding ? "none" : "default"}
                sortDirection={orderBy === column.id ? orderAscending : false}
            >
                <TableSortLabel
                    active={orderBy === column.id}
                    direction={asc}
                    className={sortLabel}
                >
                    {column.label}
                </TableSortLabel>
            </StyledTableCell>
        ));

    const renderTableBody = () =>
        (searchTerm ? filteredRows : rows).map((row, i) => (
            <TableRow tabIndex={-1} key={i}>
                {columns.map(column => {
                    const value = row[column.id] || "";
                    return (
                        <TableCell key={column.id} align={column.align}>
                            {value}
                        </TableCell>
                    );
                })}
            </TableRow>
        ));

    return (
        <>
            <Grid container justify="center" alignItems="center">
                <Grid item xs={12} md={6} className={gridElLeft}>
                    <TextField
                        type="search"
                        label="Search"
                        className={inputMobile}
                        variant="outlined"
                        value={searchTerm}
                        onChange={setTheSearchTerm}
                    />
                </Grid>
                <Grid item xs={12} md={6} className={gridElRight}>
                    <ExcelExport approveBtn={approveBtn} {...userTableProps} />
                </Grid>
            </Grid>
            <Paper className={tableRoot}>
                <TableContainer className={tableContainer}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>{renderStyledTableCell()}</TableRow>
                        </TableHead>
                        <TableBody>{renderTableBody()}</TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    );
};

export default VacationHourTable;
